module.exports = "/_next/static/images/e26d74c9f5de7367c35c87d1cbf4f2ea-pj-man-in-denim-jacket@md.jpg";